import http from "../common/api";
import { ApiSettings } from "application";

const loadBillIssuerDispatch = async (data = "") => {
  return await http.get(ApiSettings.loadBillIssuerDispatch + data, {});
};

export default loadBillIssuerDispatch;
